import React, { useEffect, useState } from 'react';
import configData from '../configData.json';
import Spinner from 'react-bootstrap/Spinner';
import SelectSearch, { fuzzySearch } from "react-select-search";
import DatePicker from 'react-date-picker';
import moment from 'moment';
import "../style/select-search.css";


export default function RightFilterToggleContent(props) {

    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date(toDate.getFullYear(), 0, 1, 23, 59, 59));

    const [owners, setOwners] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [carriers, setCarriers] = useState([{ value: 0, name: "-- Select A Value --" }]);
    const [selectedOwner, setSelectedOwner] = useState(0);
    const [selectedCust, setSelectedCust] = useState(0);
    const [selectedCarrier, setSelectedCarr] = useState(0);
    const [selectedProNumber, setSelectedFb] = useState('');
    const [selectedAccountNumber, setSelectedAccountNumber] = useState('');
    const [selectedFromDate, setSelectedFromDate] = useState(moment(fromDate).format().substring(0, 10));
    const [selectedToDate, setSelectedToDate] = useState(moment(toDate).format().substring(0, 10));
    const [ownerLoading, isOwnerLoading] = useState(false);
    const [customerLoading, isCustomerLoading] = useState(false);
    const [carrierLoading, isCarrierLoading] = useState(false);


    const LoadOwners = async () => {
        // debugger;
        isOwnerLoading(true);
        const custUrl = `${configData.BASE_APP_URL}Owner/GetOwnerList`;
        await fetch(custUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let ownerOptions = [];
                resp.map(owner => {
                    const own = {
                        "name": owner.ownerName,
                        "value": owner.ownerID
                    }
                    ownerOptions = [...ownerOptions, own];
                })
                const defaultOwner = {
                    "name": "--Select A Value--",
                    "value": 0
                }
                ownerOptions.unshift(defaultOwner);
                setOwners(ownerOptions)
            })
        isOwnerLoading(false);
        LoadCustomer(0);
    }

    const LoadCustomer = async (ownerKey) => {
        // debugger;
        setSelectedOwner(ownerKey);
        isCarrierLoading(true);
        const custUrl = `${configData.BASE_APP_URL}Customer/GetCustomerList/${ownerKey}`;
        await fetch(custUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let customerOptions = [];
                resp.map(customer => {
                    const cust = {
                        "name": customer.customerName,
                        "value": customer.customerKey
                    }
                    customerOptions = [...customerOptions, cust];
                })
                const defaultCustomer = {
                    "name": "--Select A Value--",
                    "value": 0
                }
                customerOptions.unshift(defaultCustomer);
                setCustomers(customerOptions)
            })
        isCarrierLoading(false);

    }

    const LoadCarrier = async (customerKey) => {
        // debugger;
        isCarrierLoading(true);
        setSelectedCust(customerKey);
        const URL = `${configData.BASE_APP_URL}Carrier/GetCarrierList/${customerKey}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => {
                let carrierOptions = [];
                resp.map((carrier) => {
                    const carr = {
                        "name": carrier.carrierName,
                        "value": carrier.carrierKey
                    }
                    carrierOptions = [...carrierOptions, carr];

                })
                if (customerKey > 0) {
                    const allCarrier = {
                        "name": "-- ALL TRANSPORTATION PROVIDERS  --",
                        "value": 0
                    }
                    carrierOptions.unshift(allCarrier);
                }
                else {
                    const defaultCarrier = {
                        "name": "-- Select A Value --",
                        "value": 0
                    }
                    carrierOptions.unshift(defaultCarrier);
                }
                setCarriers(carrierOptions)
            })
        isCarrierLoading(false);
    }

    const ClearFilter = async (e) => {
        // debugger;
        e.preventDefault();
        setSelectedOwner(0);
        setSelectedCust(0);
        setSelectedCarr(0);
        setSelectedFb('');
        setSelectedAccountNumber('');
        document.getElementById('pronumber').value = '';
        document.getElementById('accountnumber').value = '';
        setToDate(new Date());
        setFromDate(new Date(new Date().getFullYear(), 0, 1, 23, 59, 59));

        let customerOptions = [];
        const defaultCustomer = {
            "name": "-- Select A Value --",
            "value": 0
        }
        customerOptions.unshift(defaultCustomer);
        setCustomers(customerOptions);


        let carrierOptions = [];
        const defaultCarrier = {
            "name": "-- Select A Value --",
            "value": 0
        }
        carrierOptions.unshift(defaultCarrier);
        setCarriers(carrierOptions);
    }


    const LoadBills = async (e) => {
        debugger;
        e.preventDefault();
        if (selectedOwner === 0) {
            document.getElementById("owner-error-message").innerHTML = "Owner is a Required Field, a selection must be made";
            return;
        }
        else {
            document.getElementById("owner-error-message").innerHTML = "";
        }

        if (selectedCust === 0) {
            document.getElementById("customer-error-message").innerHTML = "Customer is a Required Field, a selection must be made";
            return;
        }
        else {
            document.getElementById("customer-error-message").innerHTML = "";
        }

        var today = new Date();
        // debugger;
        var myFromdate = new Date(selectedFromDate);

        if (myFromdate.toString() == 'Invalid Date') {
            document.getElementById("fromentry-date-error-message").innerHTML = 'Invalid Date'
            return;
        }


        if (myFromdate > today) {
            console.log(selectedFromDate);
            return;
        }

        var myTodate = new Date(selectedToDate);

        if (myTodate.toString() == 'Invalid Date') {
            document.getElementById("toentry-date-error-message").innerHTML = 'Invalid Date'
            return;
        }

        if (myTodate > today) {
            console.log(selectedToDate);
            return;
        }

        if (myFromdate > myTodate) {
            return;
        }

        props.onSearchClick(selectedCust, selectedCarrier, selectedFromDate, selectedToDate, selectedProNumber, selectedAccountNumber);
    }

    useEffect(() => {
        LoadOwners();
    }, [])

    const onOwnerSelect = (e) => {
        // debugger;
        var ownerkey = e;
        if (ownerkey > 0) {
            document.getElementById("owner-error-message").innerHTML = "";
        }
        LoadCustomer(e);
        setSelectedCust(0);
        LoadCarrier(0);


    };

    const onCustomerSelect = (e) => {
        // debugger;
        var custkey = e;
        if (custkey > 0) {
            document.getElementById("customer-error-message").innerHTML = "";
        }
        LoadCarrier(e);
        setSelectedCarr(0);

    };

    const onCarrierSelect = (e) => {
        setSelectedCarr(e);
    };

    const selectFreightBillNumber = (e) => {
        setSelectedFb(e.target.value)
    }

    const selectAccountNumber = (e) => {
        setSelectedAccountNumber(e.target.value)
    };

    const selectFromDate = (e) => {
        debugger;
        var today = new Date();
        if (e > today) {
            document.getElementById("fromentry-date-error-message").innerHTML = "From Entry Date is greater than Current Date";
        }
        else if (e > toDate) {
            document.getElementById("fromentry-date-error-message").innerHTML = "From Entry Date is greater than To Entry Date";
        }
        else {
            document.getElementById("fromentry-date-error-message").innerHTML = "";
        }
        setFromDate(e);
        setSelectedFromDate(moment(e).format().substring(0, 10))

    };

    const selectToDate = (e) => {
        // debugger;
        var today = new Date();
        if (e > today) {
            document.getElementById("toentry-date-error-message").innerHTML = "To Entry Date is greater than Current Date";
        }
        else if (e < fromDate) {
            document.getElementById("toentry-date-error-message").innerHTML = "To Entry Date is less than From Entry Date";
        }
        else {
            document.getElementById("toentry-date-error-message").innerHTML = "";
        }
        setToDate(e);
        setSelectedToDate(moment(e).format().substring(0, 10))


    };

    return (
        <>
            <div className="mb-2 form-field">
                <div id="owner-error-message" className="text-danger"></div>
                <label>Owner</label>
                <label id="owner-highlight" className="text-danger">*</label>
                <div>
                    <SelectSearch
                        id="ddnOwner"
                        name="ddnOwner"
                        value={selectedOwner}
                        options={owners}
                        onChange={onOwnerSelect}
                        search
                        filterOptions={fuzzySearch}

                    >
                    </SelectSearch>
                </div>
                {carrierLoading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : carrierLoading}
            </div>
            <div className="mb-2 form-field">
                <div id="customer-error-message" className="text-danger"></div>
                <label>Customer</label>
                <label id="customer-highlight" className="text-danger">*</label>
                <div>
                    <SelectSearch
                        id="ddnCustomer"
                        name="ddnCustomer"
                        value={selectedCust}
                        options={customers}
                        onChange={onCustomerSelect}
                        search
                        filterOptions={fuzzySearch}
                    >
                    </SelectSearch>
                </div>
                {carrierLoading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : carrierLoading}
            </div>
            <div className="mb-2 form-field">
                <label>Transportation Provider</label>
                <div>
                    <SelectSearch
                        id="ddnCarrier"
                        name="ddnCarrier"
                        value={selectedCarrier}
                        options={carriers}
                        onChange={onCarrierSelect}
                        search
                        filterOptions={fuzzySearch}
                    >
                    </SelectSearch>
                </div>
            </div>
            <div className="mb-2 form-field">
                <label>Freight Bill/Package Number</label>
                <div>
                    <input id="pronumber" className="form-control form-control-sm" placeholder="Type to search..." onChange={selectFreightBillNumber} disabled={props.isFbNoDisabled}></input>
                </div>
            </div>
            <div className="mb-2 form-field">
                <label>Transportation Provider Account Number</label>
                <div>
                    <input id="accountnumber" className="form-control form-control-sm" placeholder="Type to search..." onChange={selectAccountNumber} disabled={props.isAccNoDisabled}></input>
                </div>
            </div>
            <div className="mb-2 form-field">
                <div id="fromentry-date-error-message" className="text-danger"></div>
                <label>From Entry Date</label>
                <label id="fromentry-highlight" className="text-danger">*</label>
                <div>
                    <DatePicker
                        value={fromDate}
                        onChange={selectFromDate}
                        calendarIcon={<i className='fas fa-calendar-alt'></i>}
                        format="MM/dd/yyyy"
                        fixedHeight
                    />
                </div>
            </div>
            <div className="mb-2 form-field">
                <div id="toentry-date-error-message" className="text-danger"></div>
                <label>To Entry Date</label>
                <label id="toentry-highlight" className="text-danger">*</label>
                <div>
                    <DatePicker
                        value={toDate}
                        onChange={selectToDate}
                        calendarIcon={<i className='fas fa-calendar-alt'></i>}
                        format="MM/dd/yyyy"
                        fixedHeight
                    />
                </div>
            </div>
            <div className="form-field mx-auto" style={{ width: "180px" }}>
                <button type="button" onClick={ClearFilter} className='btn btn-clear'>Clear</button>
                <button type="button" onClick={LoadBills} className='btn btn-filter ms-2'>Filter</button>
            </div>
        </>
    )
}
